import { render, staticRenderFns } from "./SharedBtn.vue?vue&type=template&id=4bef0233&"
import script from "./SharedBtn.vue?vue&type=script&lang=js&"
export * from "./SharedBtn.vue?vue&type=script&lang=js&"
import style0 from "./SharedBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports